module.exports = __webpack_public_path__ + "img/avatar.0fc3e034.png";